import * as React from "react";
import * as ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/core";
import { SnackbarNotifier, Theme } from "../../entryes/panel/MUI";
import ProfileStore from "../../store/profile.store";
import { Provider } from "mobx-react";
import { NewbieBanner } from "../NewbieBanner";
import FSNotifierStore from "../Notifier/store";


declare global {
  interface Window {
    react_render_courseTopBanner: (nodeId: string) => void;
  }
}

const profileStore = new ProfileStore(this);
const fsNotifierStore = new FSNotifierStore(this);

window.react_render_courseTopBanner = (nodeId: string) => {
  ReactDOM.render(
    <Provider profileStore={profileStore} fsNotifierStore={fsNotifierStore}>
      <ThemeProvider theme={Theme}>
        <NewbieBanner/>
        <SnackbarNotifier/>
      </ThemeProvider>
    </Provider>,
    document.getElementById(nodeId)
  )
}